export enum PopupTriggerTypeEnum {
    EXIT_INTENT_TRIGGER = 'EXIT_INTENT_TRIGGER',
    CODE_TRIGGER = 'CODE_TRIGGER',
    TIME_DELAY_TRIGGER = 'TIME_DELAY_TRIGGER',
}
